"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FilterableDataLoader = void 0;
const tslib_1 = require("tslib");
const app_1 = require("app");
const search_1 = require("src/search");
const webexUI_1 = require("webexUI");
const FilterTypings_1 = require("../Filters/FilterTypings");
const FilterableList_1 = require("./FilterableList");
const FilterableListService_1 = require("./FilterableListService");
class FilterableDataLoader {
    constructor(config) {
        this.defaultContactType = 'type:distributor';
        this.replaceFilterValuesForGTM = (selectedFilters, filters) => {
            const isDocTypeOrHierarchy = selectedFilters.some(filter => {
                const key = filter.split(':')[0];
                return (key === search_1.FullTextSearchFilters.DocumentationDocumentTypeFilterAlias ||
                    key === search_1.FullTextSearchFilters.DocumentationApprovalTypeFilterAlias ||
                    key === search_1.FullTextSearchFilters.DocumentationHierarchyFilterAlias ||
                    key === search_1.FullTextSearchFilters.DocumentationProductHierarchyFilterAlias ||
                    key === search_1.FullTextSearchFilters.DrawingsDrawingTypeFilterAlias ||
                    key === search_1.FullTextSearchFilters.DrawingsProductHierarchyFilterAlias);
            });
            if (!isDocTypeOrHierarchy) {
                return selectedFilters;
            }
            const mapping = this.getFiltersMapRawToGTM(filters);
            return selectedFilters.map(filter => (mapping[filter] ? mapping[filter] : filter));
        };
        this.getFiltersMapRawToGTM = (filters) => {
            const docTypeAlias = search_1.FullTextSearchFilters.DocumentationDocumentTypeFilterAlias;
            const approvalTypeAlias = search_1.FullTextSearchFilters.DocumentationApprovalTypeFilterAlias;
            const hierarchyTypeAlias = FilterTypings_1.FilterGroupTypeAlias.Hierarchy;
            const productHierarchyTypeAlias = FilterTypings_1.FilterGroupTypeAlias.ProductHierarchy;
            const filtersMapRawToGTM = {};
            filters.forEach(filterItem => {
                if (filterItem.value === docTypeAlias ||
                    filterItem.value === approvalTypeAlias ||
                    filterItem.typeAlias === hierarchyTypeAlias ||
                    filterItem.typeAlias === productHierarchyTypeAlias) {
                    filterItem.items.forEach(item => {
                        if (item.selected) {
                            filtersMapRawToGTM[item.value] = `${item.value.split(':')[0]}:${item.title}`;
                        }
                    });
                }
            });
            return filtersMapRawToGTM;
        };
        this.config = config;
    }
    loadData(selectedFiltersList, pageNumber, pageSize, sortBy, query, filterChange, search, isInitialSearch) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const { pageId, dataLoadedSuccessHandler, storeFiltersInHistory, service, pageName } = this.config;
            const subsequentSearch = search && search.subsequent;
            let selectedFilters = this.prepareSelectedFilters(selectedFiltersList, pageNumber, pageSize, sortBy, subsequentSearch);
            FilterableListService_1.FilterableListService.addFiltersToUrl(selectedFilters, pageNumber, pageSize, sortBy, storeFiltersInHistory);
            const pageProps = {
                pageNumber,
                pageid: pageId,
            };
            const dataPromise = service
                .getData(selectedFilters, pageProps, sortBy, pageSize, query, isInitialSearch)
                .then(data => {
                return data;
            });
            this.initDataPromise = this.getInitialFilters();
            try {
                const [filteredData, initialData] = yield Promise.all([dataPromise, this.initDataPromise]);
                this.initDataPromise = null;
                this.initData = initialData;
                // Refreshing selected filters when doing recurrent call
                if (filteredData.recurrentCall) {
                    const newSelectedFilters = FilterableListService_1.FilterableListService.getFiltersFromUrl();
                    selectedFilters = this.prepareSelectedFilters(newSelectedFilters.filters, pageNumber, pageSize, sortBy, false);
                }
                if (this.isDataLoadedSuccessfully(filteredData)) {
                    dataLoadedSuccessHandler(filteredData, initialData, selectedFilters);
                }
                const data_2 = {
                    filteredData,
                    initialData,
                    selectedFilters,
                };
                // check dataLayer object and push data
                if (filterChange) {
                    this.pushFilterDataToGTM(data_2.filteredData.totalItems, pageName, selectedFiltersList, data_2.filteredData.filters);
                }
                if (search) {
                    this.pushSearchDataToGTM(data_2.filteredData.totalItems, query, search);
                }
                this.previousSelectedFilters = selectedFilters;
                return data_2;
            }
            catch (error) {
                this.initDataPromise = null;
                this.initData = null;
                console.warn(error); // tslint:disable-line:no-console
                throw error;
            }
        });
    }
    prepareSelectedFilters(selectedFilters, pageNumber, pageSize, sortBy, subsequentSearch) {
        let preparedSelectedFilters = selectedFilters;
        if (this.config.prepareSelectedFiltersHandler) {
            preparedSelectedFilters = this.config.prepareSelectedFiltersHandler(selectedFilters, pageNumber, pageSize, sortBy, subsequentSearch);
        }
        return preparedSelectedFilters;
    }
    pushFilterDataToGTM(totalItems, pageName, selectedFilters, filters) {
        const canAddToDataLayer = (0, app_1.isDataLayerSet)() && totalItems !== undefined && !!pageName;
        if (!canAddToDataLayer) {
            return;
        }
        const newFilters = this.getNewlySelectedFilters(selectedFilters);
        const newTransformedFilter = this.replaceFilterValuesForGTM(newFilters, filters)[0];
        if (newTransformedFilter) {
            const gtmFilterData = app_1.UrlService.decodeFiltersForGTM(newTransformedFilter);
            if (gtmFilterData) {
                const gtmData = Object.assign({ numberOfResults: totalItems, pageName }, gtmFilterData);
                app_1.GTM.filter(gtmData);
            }
        }
    }
    pushSearchDataToGTM(totalItems, query, search) {
        if (!search) {
            return;
        }
        app_1.GTM.search({
            refinement: search.subsequent,
            resultsCount: totalItems,
            searchQuery: query,
            sessionId: app_1.SessionService.GetSessionId(),
            suggestion: false,
        });
    }
    getNewlySelectedFilters(selectedFilters) {
        // if filters doesn't contain type filter adding default contact type filter (type:distributor)
        const prevFiltersWithType = this.pushDefaultTypeFilter(this.previousSelectedFilters);
        const newlySelectedFilters = (0, webexUI_1.safe)(selectedFilters).filter(filter => {
            return (0, webexUI_1.safe)(prevFiltersWithType).indexOf(filter) < 0;
        });
        const isAllNewlySelectedFiltersHierarchy = newlySelectedFilters.every(filter => {
            const selectedFilterAlias = filter.split(':')[0];
            return (selectedFilterAlias === search_1.FullTextSearchFilters.DocumentationHierarchyFilterAlias ||
                selectedFilterAlias === search_1.FullTextSearchFilters.DocumentationProductHierarchyFilterAlias ||
                selectedFilterAlias === search_1.FullTextSearchFilters.DrawingsProductHierarchyFilterAlias);
        });
        if (newlySelectedFilters.length > 1 && isAllNewlySelectedFiltersHierarchy) {
            const longestHierarchyFilter = newlySelectedFilters.reduce((acc, cur) => acc.length > cur.length ? acc : cur);
            return [longestHierarchyFilter];
        }
        return newlySelectedFilters;
    }
    getInitialFilters() {
        const { pageId, service } = this.config;
        const pageProps = {
            pageNumber: -1,
            pageid: pageId,
        };
        if (this.initDataPromise) {
            return this.initDataPromise;
        }
        else if (this.initData && Object.keys(this.initData).length > 0) {
            return Promise.resolve(this.initData);
        }
        return service.getData([], pageProps, '', 0);
    }
    isDataLoadedSuccessfully(filteredData) {
        const status = filteredData ? filteredData.status : null;
        return !status || !status.statusCode || status.statusCode !== FilterableList_1.ListStatusCode.communicationError;
    }
    pushDefaultTypeFilter([...selectedFilters]) {
        const isTypeFilterSelected = selectedFilters.some(filter => filter.indexOf('type:') >= 0);
        if (!isTypeFilterSelected) {
            selectedFilters.push(this.defaultContactType);
        }
        return selectedFilters;
    }
}
exports.FilterableDataLoader = FilterableDataLoader;
